/**
 * Wizard steps — pure data. Each step lists the generator section ids it
 * shows (matching constants/generatorSections.js), so the wizard renders
 * from the same registry the long form used and no field logic moves.
 */

export const WIZARD_STEPS = [
  { id: 'document', title: 'Document', fields: ['documentType', 'industry', 'category', 'purpose'] },
  {
    id: 'brand',
    title: 'Brand',
    fields: [
      'audience', 'brandPersonality', 'region', 'language',
      'campaignTitle', 'brandName', 'logo', 'brandColors', 'contactDetails',
    ],
  },
  { id: 'design', title: 'Design', fields: ['visualTheme', 'layoutStyle', 'imageStyle', 'colorMood', 'typographyStyle'] },
  { id: 'generation', title: 'Generation Settings', fields: ['batchSize', 'quality', 'variation', 'images'] },
  { id: 'review', title: 'Review', fields: [] },
];
